// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "type", "stock" , "location"]

  initialize() {
    this.displayControls()
  }

  select() {
    this.displayControls()
  }

  displayControls() {
    if (this.typeTarget.value == "assets") {
      this.stockTarget.style.visibility="hidden"
      this.locationTarget.style.visibility="hidden"
    }
    else {
      this.stockTarget.style.visibility="visible"
      this.locationTarget.style.visibility="visible"
    }
  }
}
